"use strict";
exports.__esModule = true;
exports.HISTORY = void 0;
exports.HISTORY = {
    HEADER: 'History',
    NO_TRANSACTIONS: 'All your completed payments to Flex and our rent payments to your property will show up here.',
    ERROR: 'Couldn’t load rent history'
};
